import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'formatearDias',
  standalone: false
})
export class FormatearDiasPipe implements PipeTransform {
  transform(value?: string): string {
    if (!value) return '';
    const dias = value.split(',').map(d => this.acentuar(d.trim().toLowerCase()));

    if (dias.length <= 1) return dias.join('');
    const ultimos = dias.splice(-1, 1);
    return dias.join(', ') + ' y ' + ultimos;
  }

  private acentuar(dia: string): string {
    const mapa: { [key: string]: string } = {
      lunes: 'Lunes',
      martes: 'Martes',
      miercoles: 'Miércoles',
      jueves: 'Jueves',
      viernes: 'Viernes',
      sabado: 'Sábado',
      domingo: 'Domingo'
    };
    return mapa[dia] || dia.charAt(0).toUpperCase() + dia.slice(1);
  }
}
